.container {
  max-width: 1180px;
  margin: 1rem auto 0;
  padding: 4.5rem;
  display: block;
  text-align: start;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background:
    radial-gradient(circle at 85% 22%, rgb(99 91 255 / 0.18), transparent 22rem),
    #0b1220;
  box-shadow: var(--shadow-2xl);

  &::after {
    content: "";
    position: absolute;
    inset: 0 0 0 60%;
    opacity: 0.38;
    background-image: radial-gradient(circle, #635bff 1px, transparent 1px);
    background-size: 16px 16px;
    mask-image: linear-gradient(90deg, transparent, black);
  }
}

.content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 3rem;
  align-items: center;
}

.title {
  margin-bottom: 0.5rem;
  grid-column: 1;
  color: var(--color-foreground);
}

.subtitle {
  margin-bottom: 0;
  grid-column: 1;
  max-width: 600px;
  color: var(--color-foreground);
}

.actions {
  display: flex;
  gap: 1.5rem;
  justify-content: flex-start;
  flex-wrap: wrap;

  grid-column: 2;
  grid-row: 1 / 4;
  align-self: center;
}

@media (max-width: 768px) {
  .container {
    padding: 3.5rem 1.5rem;
    text-align: center;
  }

  .content {
    display: block;
  }

  .subtitle {
    margin-bottom: 2rem;
    margin-inline: auto;
  }

  .actions {
    flex-direction: column;
    align-items: stretch;

    a {
      width: 100%;
    }
  }

}

.contact {
  grid-column: 1;
  margin: 2rem 0 0;
}
